import { Injectable, inject } from '@angular/core';
import { WebsocketService } from './websocket.service';
import { SocketConfig } from './websocket.models';

@Injectable({
  providedIn: 'root',
})
export class WebsocketFacade {
  private readonly websocketService = inject(WebsocketService);

  readonly messages$ = this.websocketService.messages$;
  readonly opened$ = this.websocketService.opened$;
  readonly closed$ = this.websocketService.closed$;
  readonly reconnecting$ = this.websocketService.reconnecting$;
  readonly errors$ = this.websocketService.errors$;

  connect(config: SocketConfig): Promise<void> {
    return this.websocketService.connect(config);
  }

  disconnect(): Promise<void> {
    return this.websocketService.disconnect();
  }

  subscribe(channel: string): Promise<void> {
    return this.websocketService.subscribe(channel);
  }

  unsubscribe(channel: string): Promise<void> {
    return this.websocketService.unsubscribe(channel);
  }

  isConnected(): boolean {
    return this.websocketService.isConnected();
  }
}